/* 
Common code for each of the views making up the levy collection setup page.
*/
import levyCollectionMixins from "@/views/levy-collections/mixins";

export default {
  mixins: [levyCollectionMixins],
  data() {
    return {
      showInitialSetupDialog: false
    };
  },
  computed: {
    title() {
      return this.loaded ? `${this.levyCollectionDescription} levy collection setup` : "Levy collection setup";
    },
    isSetup() {
      if (this.loading) {
        return true;
      }
      return this.levyCollection.isSetup;
    }
  },
  watch: {
    isSetup() {
      if (!this.isSetup) {
        this.showInitialSetupDialog = true;
      }
    }
  },
  mounted() {
    if (!this.isSetup) {
      this.showInitialSetupDialog = true;
    }
  }
};
